var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUzcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.492 10.18c0 2.798-.64 4.883-1.917 6.241-1.278 1.359-3.252 2.038-5.914 2.038q-3.73 0-5.66-2.038-1.929-2.037-1.929-6.146v-9.19c0-.214.175-.389.39-.39h4.51c.215.001.39.176.39.39v9.391q-.002 1.678.628 2.586a2.28 2.28 0 0 0 3.597.055q.616-.855.615-2.52V8.84h5.29z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.084 7.812h-4.88V1.104a.41.41 0 0 1 .408-.408h.73a4.15 4.15 0 0 0 4.15 4.146v2.97z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F4821F",
  fillRule: "evenodd",
  d: "M16.38.695h2.703a.41.41 0 0 1 .408.409v2.705A3.11 3.11 0 0 1 16.381.7z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.452 22.52h-.355v-1.226h.355a.574.574 0 0 1 .615.614.587.587 0 0 1-.616.611zm0 .367c.615 0 1.041-.388 1.041-.979s-.427-.982-1.04-.982h-.774v1.961zm-2.578-1.064h-.438v-.53h.437a.266.266 0 1 1 0 .53zm1.011 1.556-.72-1.239a.56.56 0 0 0 .43-.582.61.61 0 0 0-.659-.632h-.918v1.961h.418v-.697h.306l.664 1.188zm-3.53-1.192h-.612l.306-.844zm.71.7-.755-1.962h-.523l-.759 1.962h.476l.124-.333h.841l.12.333zm-3.647.035a.9.9 0 0 0 .82-.482l-.36-.174a.53.53 0 0 1-.462.286.645.645 0 0 1 0-1.288.53.53 0 0 1 .462.285l.36-.177a.9.9 0 0 0-.82-.48 1.015 1.015 0 1 0 0 2.03m-1.996-.035v-.368h-.947l.926-1.26v-.334H6.928v.367h.926l-.926 1.256v.337zm-3.464.035c.597 0 .886-.332.886-.82v-1.177h-.428v1.165a.46.46 0 1 1-.92 0v-1.165h-.424v1.18c0 .482.288.818.885.818zm15.043-2.032v.004a.365.365 0 1 1-.366-.365h.366z",
  clipRule: "evenodd"
})));
export default SvgUzcard;